<div class="reassuranceContainer" [ngClass]="{'d-none d-md-block': selectedForm}">
  <div *ngIf="showInformationMessage" class="informationMessage">
    <div class="informationMessage__title vc-text-m" i18n="@@GET_PAID.TITLE">Get paid</div>
    <p class="informationMessage__content vc-text-m" i18n="@@GET_PAID.INFORMATION_MESSAGE">
      To get your payment processed, we need a few personal details from you, as well as your preferred transfer method.
    </p>
  </div>

  <div *ngIf="doneForNow" class="description__container">
    <div class="description__title vc-text-m">
      <vc-sprite-icons class="description__icon" name="check"></vc-sprite-icons>
      <span i18n="@@GET_PAID.REASSURANCE.DONE_FOR_NOW.TITLE">
        You are done for now
      </span>
    </div>
    <div class="description__text vc-text-m" i18n="@@GET_PAID.REASSURANCE.DONE_FOR_NOW.DESCRIPTION">
      Thank you for uploading the requested informations, you are done for now, we might need some additional
      informations in the future.
    </div>
  </div>

  <div *ngIf="allDone" class="description__container">
    <div class="description__title vc-text-m">
      <vc-sprite-icons class="description__icon" name="check"></vc-sprite-icons>
      <span i18n="@@GET_PAID.REASSURANCE.ALL_DONE.TITLE">
        You are all done
      </span>
    </div>
    <div class="description__text vc-text-m" i18n="@@GET_PAID.REASSURANCE.ALL_DONE.DESCRIPTION">
      Congrats! you are all set to experiment our new payment system.
    </div>
  </div>
</div>
